import styled from "styled-components";

import RichText from "../rich-text";

const StyledLink = styled.a`
  color: #2797fe;
  border-bottom: 1px solid #2797fe;
`;

const Hyperlink = ({ content, data: { uri } }) => {
  return (
    <StyledLink href={uri}>
      <RichText content={content} />
    </StyledLink>
  );
};

export default Hyperlink;
